<template>
    <modal
       :title="translations.referralUrl || 'Referral URL'"
       :cancel_btn_title="translations.cancel || 'Cancel'"
       size="small"
       name="partner_update_custom_link"
       @modalClose="modalClose"
    >
        <template #toggle>
            <options-item
                :title="translations.updateReferralUrl || 'Edit'"></options-item>
        </template>
        <template #body>
            <div class="space-y-4">
                <div>
                    <label class="block text-sm opacity-80 mb-1.5">Link key</label>
                    <text-field
                        v-model="custom_link.key"
                        :error="error"
                        :error-message="error"
                    ></text-field>
                </div>
                <div class="py-3 px-4 text-sm bg-gray-100 rounded truncate">
                    <span class="opacity-60">{{ exampleUrl }}</span>
                </div>
            </div>
        </template>
        <template #footer>
            <btn v-on:click="updateCustomLink" :loading="loading" :disabled="loading">
                {{ translations.update || 'Update' }}
            </btn>
        </template>
    </modal>
</template>
<script>
export default {
    props: ['partner_custom_link', 'update_url', 'translations'],
    data() {
        return {
            error: false,
            loading: false,
            custom_link: JSON.parse(this.partner_custom_link),
            custom_link_backup: JSON.parse(this.partner_custom_link),
        }
    },
    methods: {
        updateCustomLink() {
            this.error = false;
            this.loading = true;

            axios
                .post(this.update_url, {link_id: this.custom_link.id, key: this.custom_link.key})
                .then(response => {
                    const status = parseInt(response.data.status || 0);
                    if (status === 1) {
                        this.emitter.emit('modal-off', 'partner_update_custom_link');
                        window.location.reload();
                    } else {
                        this.error = 'Failed to update custom referral key';
                    }
                })
                .catch(error => {
                    let errors = error.response.data.errors.key || error.response.data.errors || false;
                    this.error = Array.isArray(errors) ? errors[0] : errors;
                }).finally(() => this.loading = false);
        },
        modalClose() {
            this.custom_link = {...this.custom_link_backup};
        },
    },
    computed: {
        exampleUrl() {
            return this.custom_link_backup.url.replace(this.custom_link_backup.key, this.custom_link.key);
        }
    }
}
</script>
